import type { DynamicClient } from '../../../../client/types/DynamicClient';
import type { WalletAccount } from '../../walletAccount';

type GetVerifiedCredentialForWalletAccountParams = {
  walletAccount: WalletAccount;
};

export const getVerifiedCredentialForWalletAccount = (
  { walletAccount }: GetVerifiedCredentialForWalletAccountParams,
  client: DynamicClient
) => {
  return client.user?.verifiedCredentials.find(
    (vc) => vc.id === walletAccount.verifiedCredentialId
  );
};
